import { FuelIcon, FuelButton } from '@frete.com/fuel-react'
import styled from 'styled-components'

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  border-radius: ${({ theme }) => theme.border.radius.large};
  gap: ${({ theme }) => theme.spacing.km6};
  background: ${({ theme }) => theme.color.background.brand.weakest};
  padding: ${({ theme }) => theme.padding.km3} ${({ theme }) => theme.padding.km6};
  margin-top: ${({ theme }) => theme.spacing.km3};
`

const IconDanger = styled.div`
  color: ${({ theme }) => theme.color.text.danger.default};
`

const DangerIcon = styled(FuelIcon)`
  color: ${({ theme }) => theme.color.text.danger.default};
`

const ButtonReload = styled(FuelButton)`
  border: none;
  color: ${({ theme }) => theme.color.text.neutral.strong};
  text-decoration: underline;
  background-color: transparent;
  font-size: ${({ theme }) => theme.font.size.m3};
  cursor: pointer;
`

export { IconDanger, DangerIcon, Wrapper, ButtonReload }
